/** Map FastAPI `detail` (error code or legacy string) to a localized message. */
export function translateApiError(t, detail) {
  if (!detail) return t("errors.generic");
  const code = typeof detail === "string" ? detail.trim() : "";
  if (/^[a-z][a-z0-9_]*$/.test(code)) {
    const msg = t(`errors.${code}`, "");
    if (msg && msg !== `errors.${code}`) {
      if (code === "password_too_short") return t("errors.password_too_short", "", { min: 8 });
      return msg;
    }
  }
  const legacy = {
    "Not authenticated": "not_authenticated",
    "Invalid token type": "invalid_token_type",
    "User not found": "user_not_found",
    "Admin access required": "admin_required",
    "Token expired": "token_expired",
    "Invalid token": "invalid_token",
    "Invalid email or password": "invalid_email_or_password",
    "Current password is incorrect": "current_password_incorrect",
    "New password must be different from current password": "password_must_differ",
    "Lead not found": "lead_not_found",
  };
  const mapped = legacy[code];
  if (mapped) return translateApiError(t, mapped);
  if (code.includes("at least") && code.includes("characters")) {
    return t("errors.password_too_short", "", { min: 8 });
  }
  return typeof detail === "string" ? detail : t("errors.generic");
}
